import * as React from "react";
import { Navigate } from "react-router";
import type { FeatureNavModule, FeatureRouteModule } from "../types";
import { MemoryPage } from "@/pages/memory";

export const artifactsRoutes: FeatureRouteModule = {
  shellRoutes: [
    {
      path: "artifacts",
      element: React.createElement(Navigate, { to: "/settings/artifacts", replace: true }),
    },
    {
      path: "artefacts",
      element: React.createElement(Navigate, { to: "/settings/artifacts", replace: true }),
    },
    {
      path: "evidence",
      element: React.createElement(Navigate, { to: "/settings/artifacts", replace: true }),
    },
    {
      path: "repositories",
      handle: { title: "Repositories" },
      element: React.createElement(Navigate, { to: "/settings/repositories", replace: true }),
    },
    { path: "memory", handle: { title: "Memory" }, element: React.createElement(MemoryPage) },
  ],
  shellRouteDefs: [
    {
      path: "/settings/artifacts",
      title: "Project artifacts",
      summary: "Evidence packs, memory, and repositories kept in project settings.",
    },
    {
      path: "/settings/repositories",
      title: "Repositories",
      summary:
        "Bound repositories with role, branch, and webhook state, plus the pull requests runs opened.",
    },
    {
      path: "/memory",
      title: "Memory",
      summary: "Manual facts kept in this project. Sources are recorded but not indexed yet.",
    },
  ],
};

export const artifactsNav: FeatureNavModule = {};
